import { render, staticRenderFns } from "./blocker.vue?vue&type=template&id=82200a74"
import script from "./blocker.vue?vue&type=script&lang=js"
export * from "./blocker.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports